"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SolutionsDeepDive() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="260660" id="solutions-deep-dive" className="bg-background text-foreground py-16 md:py-24 overflow-hidden relative">
      {/* Subtle background pattern placeholder - maintaining structure */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[radial-gradient(#000_1px,transparent_1px)] [background-size:20px_20px]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={textRef} className={`transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6 font-default leading-tight tracking-tight">
              Custom Software & Web Solutions for Modern Enterprise
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed font-default mb-8">
              We engineer bespoke digital ecosystems that drive operational excellence. From high-performance web applications to scalable mobile platforms, our development process focuses on creating intuitive user experiences backed by robust, future-proof architecture. We don't just build software; we create the digital backbone that allows your business to scale without friction in an increasingly competitive global market.
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="h-2 w-2 rounded-md bg-primary" />
                <span className="text-foreground font-medium font-default">Full-Stack Web & Mobile Development</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-2 w-2 rounded-md bg-primary" />
                <span className="text-foreground font-medium font-default">Legacy System Modernization</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-2 w-2 rounded-md bg-primary" />
                <span className="text-foreground font-medium font-default">Cloud-Native Architecture Design</span>
              </div>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`transition-all duration-1000 ease-out delay-200 ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/enterprise_software_dashboard.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/enterprise_software_dashboard.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/enterprise_software_dashboard.png-wvc-sizes" alt="Advanced enterprise software dashboard showing data analytics and system health" className="w-full h-auto rounded-lg shadow-xl object-cover border border-border/50" loading="lazy" />
          </div>

        </div>
      </div>
    </section>;
}